"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateElementId = exports.generateString = exports.generateStringFromValues = void 0;
const nullables_1 = require("./nullables");
// TODO: Refactor it in more functional approach
/**
 * @param length number of characters in generted string
 * @param possibleValues string of values to generate from
 * @return generated string or undefined if length < 0 or possibleValues is empty
 */
function generateStringFromValues(length, possibleValues) {
    if (length <= 0) {
        return undefined;
    }
    if ((0, nullables_1.isEmptyString)(possibleValues)) {
        return undefined;
    }
    // eslint-disable-next-line functional/no-let
    let text = '';
    // eslint-disable-next-line functional/no-let,functional/no-loop-statements
    for (let i = 0; i < length; i++) {
        text += possibleValues.charAt(Math.floor(Math.random() * possibleValues.length));
    }
    return text;
}
exports.generateStringFromValues = generateStringFromValues;
/**
 * @param length number of characters in generated string
 * @return generated string or undefined if length < 0
 */
const generateString = (length) => generateStringFromValues(length, 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789');
exports.generateString = generateString;
function generateElementId() {
    const numbersLength = 17;
    const lettersLength = 2;
    // eslint-disable-next-line
    const randLetters = generateStringFromValues(lettersLength, 'abcdefghijklmnopqrstuvwxyz');
    // eslint-disable-next-line
    const randNumbers = generateStringFromValues(numbersLength, '0123456789');
    return `${randLetters}_${randNumbers}`;
}
exports.generateElementId = generateElementId;
